import { z } from "zod";
import { scopeDefinitionSchema } from "../apiDefinitions/api/tags";

export const tagsSchema = z.string().transform((tags) => {
  try {
    const parsed = JSON.parse(tags);
    return Array.isArray(parsed) ? (parsed.flat() as string[]) : [];
  } catch {
    return [];
  }
});

const tagsEnhancedItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: z.string(),
  origin: z.string(),
  color: z.string(),
  scope_definition: scopeDefinitionSchema,
  marketplace: z.string(),
});

export type TagsEnhancedItem = z.infer<typeof tagsEnhancedItemSchema>;

export const tagsEnhancedSchema = z.array(tagsEnhancedItemSchema).catch([]);
